import React from 'react';
import Icon from './Icon';

export default class Edit extends Icon {
  icon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g fill="none" fillRule="currentColor">
        <rect
          width="24"
          height="24"
          fill="#FFF"
          fillRule="nonzero"
          stroke="#E9E9E9"
          rx="12"
        />
        <g fill="#485465">
          <path
            d="M7.796 11.704c1.052 0 1.905-.838 1.905-1.871V5.487c0-.238-.197-.431-.44-.431s-.44.193-.44.431v4.346c0 .556-.459 1.007-1.025 1.007H1.905c-.567 0-1.026-.45-1.026-1.007v-7.08c0-.556.46-1.007 1.026-1.007H5.45c.243 0 .44-.193.44-.432 0-.238-.197-.431-.44-.431H1.905C.853.883 0 1.72 0 2.753v7.08c0 1.033.853 1.87 1.905 1.87h5.89z"
            transform="translate(6.64 6)"
          />
          <path
            d="M9.797 1.85L5.511 6.065l-1.18.399.404-1.18 4.27-4.215c.173-.252.521-.318.776-.147.256.17.323.514.15.766-.04.058-.09.108-.15.147l.016.015zM10.45.425c-.58-.567-1.515-.567-2.096 0L4.005 4.716c-.048.048-.085.106-.109.169l-.76 2.176c-.086.24.04.502.283.587.049.017.1.026.151.026l.155-.03 2.19-.736c.064-.023.122-.06.17-.107l4.349-4.292c.587-.569.596-1.5.019-2.08l-.004-.004z"
            transform="translate(6.64 6)"
          />
        </g>
      </g>
    </svg>
  );
}
